module.exports = "<div [ngClass]=\"{'rtl': isArabic}\">\n    <router-outlet></router-outlet>\n</div>\n"